export const escapedEmSt = /\\\*|\\_/g
